// 活動任務區塊
import CampaignTaskComponent from './CampaignTaskComponent'; // 任務元件

const CampaignTasks = ({ tasks, completedTaskIds, spinSlug, drawTime }) => {
    // 每日任務
    const dailyTasks = tasks.filter((task) => task.type === 'daily');
    // 單次任務
    const oneTimeTasks = tasks.filter((task) => task.type === 'oneTime');

    return (
        <section
            className="relative my-[50px] [&>.title]:between-center [&>.title>h6]:text-white [&>.title>h6]:text-h5
            [&>.title>p]:text-btn1 [&>.title>p]:text-[#00B5D3] [&>.title]:mb-[15px] [&>.title]:umd:flex-col [&>.title]:umd:items-start [&>.title]:umd:gap-y-[10px]"
        >
            <hr id="tasks" className="opacity-0 absolute top-[-50px] z-[-1]" />
            <div className="title">
                <h6>每日任務</h6>
                <p>*每日任務將於每晚 {drawTime} 進行重置</p>
            </div>

            {/* 每日任務 */}
            <div className="space-y-[10px] mb-[40px]">
                {dailyTasks?.map((task, i) => (
                    <CampaignTaskComponent
                        key={task?.id + 'task' + i}
                        task={{ ...task, isFinish: completedTaskIds?.includes(task?.id) }}
                        order={i + 1}
                        spinSlug={spinSlug}
                    />
                ))}
            </div>

            <div className="title">
                <h6>完成單次任務獲得額外獎勵</h6>
                <p>*單次任務轉盤次數不會每日重置</p>
            </div>

            {/* 單次任務 */}
            <div className="space-y-[10px]">
                {oneTimeTasks?.map((task, i) => (
                    <CampaignTaskComponent
                        key={task?.id + 'task' + i}
                        task={{ ...task, isFinish: completedTaskIds?.includes(task?.id) }}
                        order={i + 1 + dailyTasks?.length}
                        spinSlug={spinSlug}
                    />
                ))}
            </div>
        </section>
    );
};

export default CampaignTasks;
